/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PersonalReductionRequisition { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    employeeId?: number;
    employeeName: string;
    employeeEnrollment?: string;
    employeeCompany?: string;
    employeeDepartment?: string;
    employeeDepartmentId?: string;
    employeeArea?: string;
    transactionEffectiveDate?: string;
    movementType: number;
    reason?: string;
    other?: string;
    token?: string;
    code?: string;
    companyId?: string;
    humanCapitalCompanyId?: string;
    statusId?: string;
    createdByUser?: object;
}

